exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.m-t[data-v-3f51f392] {\n  margin-top: 14px;\n}\n.claim-refund-icon-checkmark[data-v-3f51f392] {\n  font-size: 16px;\n  color: #2db300;\n  padding-right: 6px;\n}\n.claim-refund-icon-arrow[data-v-3f51f392] {\n  color: #2db300;\n}\n.refund-msg[data-v-3f51f392] {\n  font-size: 15px;\n  color: #4c5669;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f51f392","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/claims/ClaimRefunds.vue
// module id = hF9z
// module chunks = 0